// Overzicht van de reservering met de mogelijkheid om de datum aan te passen en een notitie toe te voegen
import React, { useState, useEffect } from 'react';
import { Typography, Paper, Grid, Button, Box, TextField, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ReserveringPopup from './ReserveringPopup';

const ReserveringsData = ({   
    notitie, 
    selectedMaterials,
    setSelectedMaterials,
    reservedMaterials, 
    geselecteerdeDraaidag, 
    currentReservation, 
    reservations,
    postOrUpdateReservering 
}) => {
    const [popupOpen, setPopupOpen] = useState(false);

    // Functie om de dialoogbox te openen
    const openPopup = () => {
        setPopupOpen(true);
    };

    // Formatteer de datums voor weergave
    const formatDate = (datumString) => {
        const datum = new Date(datumString);
        return datum.toLocaleDateString('nl-NL', {
            day: '2-digit', month: '2-digit', year: 'numeric'
        });
    };

    if (!currentReservation || !currentReservation.fields) {
        return null; // Don't show anything if no reservation
    }

    return (
        <div style={{ maxHeight: '200px', overflow: 'hidden' }}>
            <Box sx={{ marginBottom: 1 }}>
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs>
                        <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>
                            {`Reservering: ${currentReservation.fields.reserveringNummer}`}
                        </Typography>
                        <Typography variant="body2" component="span" sx={{ marginLeft: 2 }}>
                            {`${formatDate(currentReservation.fields.Start)} - ${formatDate(currentReservation.fields.Eind)}`}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Tooltip title="Wijzig datum van reservering">
                            <IconButton 
                                color="primary" 
                                onClick={openPopup}
                                size="small"
                                sx={{ 
                                    backgroundColor: 'primary.main', 
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: 'primary.dark',
                                    }
                                }}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Box>

            <ReserveringPopup
                open={popupOpen}
                onClose={() => setPopupOpen(false)}
                currentReservation={currentReservation}
                updateReservation={() => {}} // Placeholder
                draaidag={geselecteerdeDraaidag}
                getDatesInRange={(start, end) => {
                    const dates = [];
                    const current = new Date(start);
                    const endDate = new Date(end);
                    while (current <= endDate) {
                        dates.push(current.toISOString().split('T')[0]);
                        current.setDate(current.getDate() + 1);
                    }
                    return dates;
                }}
                reservations={reservations}
                reservedMaterials={reservedMaterials}
                handleMaterialClickForOverlap={() => {}} // Placeholder
                overlappingReservations={[]} // Placeholder
                openReservationDialog={false} // Placeholder
                setOpenReservationDialog={() => {}} // Placeholder
                selectedMaterials={selectedMaterials}
                setSelectedMaterials={setSelectedMaterials}
                postOrUpdateReservering={postOrUpdateReservering}
            />
        </div>
    );
};

export default ReserveringsData;
